import { useEffect, useState } from 'react'

import { useHealth } from '../../hooks/queries'

/**
 * Wacht darüber, dass der Browser dieselbe Fassung fährt wie der Server.
 *
 * Der Anlass war ein handfester Fehler: auf dem iPad hing eine alte Hülle im
 * Zwischenspeicher, und weil ein FTP-Upload die alten Dateien nicht wegräumt,
 * lud sie klaglos weiter ein altes Bündel. Der Server war aktuell, das Gerät
 * nicht — und eine gerade eingebaute Sperre wirkte dort schlicht nicht.
 * Unbemerkt, denn nichts sah kaputt aus.
 *
 * Die Hülle wird inzwischen nicht mehr zwischengespeichert (`.htaccess`).
 * Diese Wache ist der zweite Riegel: sie vergleicht den eingebauten Stand mit
 * dem, was `/api/health` sagt, und lädt bei Ungleichheit **einmal** neu. Ein
 * einziges Mal je Serverstand, gemerkt in `sessionStorage` — ohne diese Marke
 * wäre eine Schleife möglich, und eine Anwendung, die sich alle zwei Sekunden
 * neu lädt, ist schlimmer als eine veraltete.
 *
 * Bleibt es danach ungleich, hilft nur noch der Mensch: dann steht es da.
 */
export function StandWache() {
  const health = useHealth(true)
  const server = health.data?.build
  const [veraltet, setVeraltet] = useState(false)

  useEffect(() => {
    // Im Entwicklungsbetrieb trägt das Bündel keinen Commit -- da wäre jeder
    // Vergleich ein Fehlalarm.
    if (!server || __BUILD__ === 'dev' || server === __BUILD__) {
      return
    }

    const marke = `tb-neu-geladen-${server}`
    if (sessionStorage.getItem(marke) !== null) {
      setVeraltet(true)
      return
    }

    sessionStorage.setItem(marke, '1')
    window.location.reload()
  }, [server])

  if (!veraltet) {
    return null
  }

  return (
    <div className="stand-wache" role="status">
      Diese Seite ist älter als der Server ({__BUILD__} statt {server}). Bitte
      die Seite neu laden — am iPhone: Safari schließen und neu öffnen.
    </div>
  )
}
